import Vue from "vue";
import uuid from "uuid/v4";

export default {
  namespaced: true,
  state: {
    locations: [],
    identifier: uuid(),
    optedIn: false
  },
  mutations: {
    OPTED_IN(state) {
      state.optedIn = true;
    }
  },
  actions: {
    LOCATION_UPDATED(context, data) {
      Vue.axios.post("/api/player/location", {
        latitude: data.lat,
        longitude: data.lng,
        identifier: context.state.identifier
      });
    },
    OPTED_IN(context) {
      Vue.prototype.$vuexGeolocation.watchPosition();
      context.commit("OPTED_IN", true);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/player.js